
<template>
  <div class="r-remark-card">
      <div class="status-radio"></div>
    <div class="date">{{config.appointmentDate}}</div>
    <div class="remark">{{config.content}}</div>
    <div class="options common-flex common-justify-between">
        <div class="common-flex common-hover" @click="edit">
            <span class="iconfont iconbianji"></span>
            <span>{{$t('customer.edit')}}</span>
        </div>
        <div class="common-flex common-hover" @click="del">
            <span class="iconfont iconshanchudizhi"></span>
            <span>{{$t('customer.delete')}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: "r-remark-card",
  data() {
    return {};
  },
  props:{
    config:Object
  },
  methods:{
    ...mapActions([
      'deleteCustomerNoteAction',//删除预约
    ]),
    edit(){
      console.log('编辑')
      this.$emit('editAppointment',this.config)
    },
    del(){
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          this.deleteCustomerNoteAction({ id:this.config.id }).then((res) => {
            if (res.code == 0) {
              this.$emit('updateAppointment',this.config)
            }
          });
        },
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-remark-card {
  padding: 20px 20px 10px;
  background: #fff;
  position: relative;
  margin-top: 10px;
  .status-radio{
      width: 5px;
      height: 5px;
      background: #0A4DCC;
      border-radius: 50%;
      position: absolute;
      top: 10px;
      right: 10px;
  }
  .date {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 14px;
  }
  .remark {
    margin: 10px 0 21px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 19px;
  }
  .options{
      font-size: 12px;
    //   transform: scale(.83);
    color: rgba(8,25,56,.4);
  }
  .iconfont{
      margin-right: 4px;
      font-size: 12px;
      transform: scale(.83);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/r-remark-card.vue